/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountParentInfo {
    getFixupPrototypeFunction() { return ServiceAccountParentInfo.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountParentInfo>): ServiceAccountParentInfo {
        let obj = Object.assign(new ServiceAccountParentInfo(), model);
        ServiceAccountParentInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountParentInfo>): ServiceAccountParentInfo {
        if (!model) return null;
        return ServiceAccountParentInfo.newInstance(<ServiceAccountParentInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountParentInfo) {
        if (!obj) return;

        models.ServiceAccountParentInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountParentInfo): boolean {
        Object.setPrototypeOf(obj, ServiceAccountParentInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.native_details) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.native_details);
        }
    }

    /**
     * ID of the parent account.
     */
    parent_id: string;

    /**
     * Name of the parent account.
     */
    parent_name: string;

    /**
     * Native details of the account. This is a required field.
     */
    native_details: models.ServiceAccountNativeDetailsBase;

}
